/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aqua_Fuzzy_Monkey_FulfillInputs */

const fr_aqua_fuzzy_monkey_fulfill = /** @type {(inputs: Aqua_Fuzzy_Monkey_FulfillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les 5 dernières demandes de drop-in`)
};

/**

* @param {Aqua_Fuzzy_Monkey_FulfillInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const aqua_fuzzy_monkey_fulfill = /** @type {((inputs?: Aqua_Fuzzy_Monkey_FulfillInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aqua_Fuzzy_Monkey_FulfillInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_aqua_fuzzy_monkey_fulfill(inputs)
});